export default __webpack_public_path__ + "static/media/Philips.4e28fedb.svg";